import { render } from "./orderDetails.vue?vue&type=template&id=c38c4590"
const script = {}
script.render = render

export default script